
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import Topics from "@/components/Topics.vue";
import Questions from "@/components/Questions.vue";
import Explore from "@/components/Explore.vue";
import Download from "@/components/Download.vue";
import Footer from "@/components/Footer.vue";

@Options({
  components: {
    Header,
    Topics,
    Questions,
    Explore,
    Download,
    Footer,
  },
  computed: {
    informePaisVariables: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      get() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.$store.state.informePaisVariables;
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      set(newValue) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.$store.state.informePaisVariables = newValue;
      },
    },
  },
  async mounted() {
    // https://docs.google.com/spreadsheets/d/1Kymn0SJRbFm2GrE8E87-NA0R9LqzyleqyArq17TVnYg/edit?usp=sharing
    const data = await this.$store.dispatch("getInformePaisVariables");
    // console.log(data);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.informePaisVariables = Object.assign({}, ...data);
    // console.log(this.informePaisVariables);
    // console.log(this.informePaisVariables["Enlace Informe País 2020"]);
  },
})
export default class Home extends Vue {}
